import fetch from './fetch';
import getAdmin from './getAdmin';
import updateAdmin from './updateAdmin';

export default {
  fetch,
  getAdmin,
  updateAdmin,
};
